const constructionPartnerTranslations = {
  en: {
    navigation: "Construction Partners",
    eyebrow: "Panatlantik delivery intelligence",
    title: "Construction Partners",
    subtitle: "Verified contractors, developers, engineering groups and strategic partners matched to Panatlantik projects.",
    discover: "Discover companies",
    addCompany: "Add company",
    total: "Total companies",
    priorityA: "Priority A partners",
    verified: "Verified companies",
    portugal: "Operating in Portugal",
    search: "Search company, project, country or speciality…",
    allCountries: "All countries",
    allRoles: "All company roles",
    allSpecialities: "All specialities",
    allPriorities: "All priorities",
    priority: "Priority",
    notice: "Internal partner intelligence. Verify company and contact information before external communication.",
    loading: "Loading construction partners…",
    loadError: "Construction partners could not be loaded.",
    noResults: "No construction companies found",
    noResultsHelp: "Import the researched companies or adjust the search filters.",
    portugalPresence: "Portugal presence",
    specialities: "Specialities",
    noDescription: "No company description recorded.",
    contactMissing: "Professional contact requires verification",
    officialWebsite: "Official website",
  },
  pt: {
    navigation: "Parceiros de Construção",
    eyebrow: "Inteligência de execução Panatlantik",
    title: "Parceiros de Construção",
    subtitle: "Empreiteiros, promotores, grupos de engenharia e parceiros estratégicos verificados para os projetos Panatlantik.",
    discover: "Descobrir empresas",
    addCompany: "Adicionar empresa",
    total: "Total de empresas",
    priorityA: "Parceiros de prioridade A",
    verified: "Empresas verificadas",
    portugal: "Operam em Portugal",
    search: "Pesquisar empresa, projeto, país ou especialidade…",
    allCountries: "Todos os países",
    allRoles: "Todas as funções",
    allSpecialities: "Todas as especialidades",
    allPriorities: "Todas as prioridades",
    priority: "Prioridade",
    notice: "Inteligência interna de parceiros. Verificar a empresa e os contactos antes de qualquer comunicação externa.",
    loading: "A carregar parceiros de construção…",
    loadError: "Não foi possível carregar os parceiros de construção.",
    noResults: "Nenhuma empresa de construção encontrada",
    noResultsHelp: "Importe as empresas pesquisadas ou ajuste os filtros.",
    portugalPresence: "Presença em Portugal",
    specialities: "Especialidades",
    noDescription: "Nenhuma descrição da empresa registada.",
    contactMissing: "O contacto profissional requer verificação",
    officialWebsite: "Website oficial",
  },
  zh: {
    navigation: "建筑合作伙伴",
    eyebrow: "Panatlantik 项目交付情报",
    title: "建筑合作伙伴",
    subtitle: "与 Panatlantik 项目匹配的已核实施工企业、开发商、工程集团和战略合作伙伴。",
    discover: "发现企业",
    addCompany: "添加企业",
    total: "企业总数",
    priorityA: "A级优先合作伙伴",
    verified: "已核实企业",
    portugal: "在葡萄牙运营",
    search: "搜索企业、项目、国家或专业领域…",
    allCountries: "所有国家",
    allRoles: "所有企业角色",
    allSpecialities: "所有专业领域",
    allPriorities: "所有优先级",
    priority: "优先级",
    notice: "内部合作伙伴情报。对外联系前请核实企业和联系人信息。",
    loading: "正在加载建筑合作伙伴…",
    loadError: "无法加载建筑合作伙伴。",
    noResults: "未找到建筑企业",
    noResultsHelp: "请导入已研究的企业或调整搜索筛选条件。",
    portugalPresence: "在葡萄牙有业务",
    specialities: "专业领域",
    noDescription: "尚未记录企业说明。",
    contactMissing: "专业联系人仍需核实",
    officialWebsite: "官方网站",
  },
  fr: {
    navigation: "Partenaires de Construction",
    eyebrow: "Intelligence de réalisation Panatlantik",
    title: "Partenaires de Construction",
    subtitle: "Entrepreneurs, promoteurs, groupes d’ingénierie et partenaires stratégiques vérifiés pour les projets Panatlantik.",
    discover: "Découvrir des entreprises",
    addCompany: "Ajouter une entreprise",
    total: "Total des entreprises",
    priorityA: "Partenaires de priorité A",
    verified: "Entreprises vérifiées",
    portugal: "Actives au Portugal",
    search: "Rechercher une entreprise, un projet, un pays ou une spécialité…",
    allCountries: "Tous les pays",
    allRoles: "Tous les rôles",
    allSpecialities: "Toutes les spécialités",
    allPriorities: "Toutes les priorités",
    priority: "Priorité",
    notice: "Intelligence interne sur les partenaires. Vérifiez l’entreprise et les contacts avant toute communication externe.",
    loading: "Chargement des partenaires de construction…",
    loadError: "Impossible de charger les partenaires de construction.",
    noResults: "Aucune entreprise de construction trouvée",
    noResultsHelp: "Importez les entreprises recherchées ou modifiez les filtres.",
    portugalPresence: "Présence au Portugal",
    specialities: "Spécialités",
    noDescription: "Aucune description de l’entreprise enregistrée.",
    contactMissing: "Le contact professionnel doit être vérifié",
    officialWebsite: "Site officiel",
  },
  es: {
    navigation: "Socios de Construcción",
    eyebrow: "Inteligencia de ejecución Panatlantik",
    title: "Socios de Construcción",
    subtitle: "Contratistas, promotores, grupos de ingeniería y socios estratégicos verificados para los proyectos Panatlantik.",
    discover: "Descubrir empresas",
    addCompany: "Añadir empresa",
    total: "Total de empresas",
    priorityA: "Socios de prioridad A",
    verified: "Empresas verificadas",
    portugal: "Operan en Portugal",
    search: "Buscar empresa, proyecto, país o especialidad…",
    allCountries: "Todos los países",
    allRoles: "Todas las funciones",
    allSpecialities: "Todas las especialidades",
    allPriorities: "Todas las prioridades",
    priority: "Prioridad",
    notice: "Inteligencia interna de socios. Verifique la empresa y los contactos antes de cualquier comunicación externa.",
    loading: "Cargando socios de construcción…",
    loadError: "No se pudieron cargar los socios de construcción.",
    noResults: "No se encontraron empresas de construcción",
    noResultsHelp: "Importe las empresas investigadas o ajuste los filtros.",
    portugalPresence: "Presencia en Portugal",
    specialities: "Especialidades",
    noDescription: "No hay una descripción registrada.",
    contactMissing: "El contacto profesional requiere verificación",
    officialWebsite: "Sitio web oficial",
  },
  de: {
    navigation: "Baupartner",
    eyebrow: "Panatlantik Ausführungsintelligenz",
    title: "Baupartner",
    subtitle: "Verifizierte Bauunternehmen, Entwickler, Ingenieurgruppen und strategische Partner für Panatlantik-Projekte.",
    discover: "Unternehmen entdecken",
    addCompany: "Unternehmen hinzufügen",
    total: "Unternehmen insgesamt",
    priorityA: "Partner mit Priorität A",
    verified: "Verifizierte Unternehmen",
    portugal: "In Portugal tätig",
    search: "Nach Unternehmen, Projekt, Land oder Fachgebiet suchen…",
    allCountries: "Alle Länder",
    allRoles: "Alle Unternehmensrollen",
    allSpecialities: "Alle Fachgebiete",
    allPriorities: "Alle Prioritäten",
    priority: "Priorität",
    notice: "Interne Partnerinformationen. Unternehmen und Kontakte vor externer Kommunikation überprüfen.",
    loading: "Baupartner werden geladen…",
    loadError: "Baupartner konnten nicht geladen werden.",
    noResults: "Keine Bauunternehmen gefunden",
    noResultsHelp: "Importieren Sie recherchierte Unternehmen oder ändern Sie die Filter.",
    portugalPresence: "Präsenz in Portugal",
    specialities: "Fachgebiete",
    noDescription: "Keine Unternehmensbeschreibung hinterlegt.",
    contactMissing: "Geschäftskontakt muss überprüft werden",
    officialWebsite: "Offizielle Website",
  },
  it: {
    navigation: "Partner di Costruzione",
    eyebrow: "Intelligence di realizzazione Panatlantik",
    title: "Partner di Costruzione",
    subtitle: "Imprese, sviluppatori, gruppi di ingegneria e partner strategici verificati per i progetti Panatlantik.",
    discover: "Scopri aziende",
    addCompany: "Aggiungi azienda",
    total: "Totale aziende",
    priorityA: "Partner con priorità A",
    verified: "Aziende verificate",
    portugal: "Operative in Portogallo",
    search: "Cerca azienda, progetto, paese o specializzazione…",
    allCountries: "Tutti i paesi",
    allRoles: "Tutti i ruoli",
    allSpecialities: "Tutte le specializzazioni",
    allPriorities: "Tutte le priorità",
    priority: "Priorità",
    notice: "Intelligence interna sui partner. Verificare azienda e contatti prima di comunicazioni esterne.",
    loading: "Caricamento dei partner di costruzione…",
    loadError: "Impossibile caricare i partner di costruzione.",
    noResults: "Nessuna impresa di costruzione trovata",
    noResultsHelp: "Importa le aziende ricercate o modifica i filtri.",
    portugalPresence: "Presenza in Portogallo",
    specialities: "Specializzazioni",
    noDescription: "Nessuna descrizione aziendale registrata.",
    contactMissing: "Il contatto professionale richiede verifica",
    officialWebsite: "Sito ufficiale",
  },
  ru: {
    navigation: "Строительные партнёры",
    eyebrow: "Аналитика реализации Panatlantik",
    title: "Строительные партнёры",
    subtitle: "Проверенные подрядчики, девелоперы, инженерные группы и стратегические партнёры для проектов Panatlantik.",
    discover: "Найти компании",
    addCompany: "Добавить компанию",
    total: "Всего компаний",
    priorityA: "Партнёры приоритета A",
    verified: "Проверенные компании",
    portugal: "Работают в Португалии",
    search: "Поиск по компании, проекту, стране или специализации…",
    allCountries: "Все страны",
    allRoles: "Все роли компаний",
    allSpecialities: "Все специализации",
    allPriorities: "Все приоритеты",
    priority: "Приоритет",
    notice: "Внутренняя информация о партнёрах. Проверяйте компанию и контакты перед внешней коммуникацией.",
    loading: "Загрузка строительных партнёров…",
    loadError: "Не удалось загрузить строительных партнёров.",
    noResults: "Строительные компании не найдены",
    noResultsHelp: "Импортируйте исследованные компании или измените фильтры.",
    portugalPresence: "Присутствие в Португалии",
    specialities: "Специализации",
    noDescription: "Описание компании не зарегистрировано.",
    contactMissing: "Профессиональный контакт требует проверки",
    officialWebsite: "Официальный сайт",
  },
};


const constructionPartnerWorkflowTranslations = {
  en: {
    form: {
      eyebrow: "Verified partner profile",
      title: "Add construction company",
      companyInformation: "Company information",
      name: "Company name",
      legalName: "Legal name",
      parentGroup: "Parent group",
      country: "Country",
      city: "City",
      website: "Official website",
      role: "Company role",
      speciality: "Speciality",
      capability: "Capability",
      description: "Description",
      professionalContact: "Professional contact",
      contactName: "Contact name or department",
      jobTitle: "Position",
      email: "Email",
      phone: "Telephone",
      contactSource: "Contact source URL",
      priority: "Priority",
      contactVerification: "Contact verification",
      operatesPortugal: "Company operates in Portugal",
      relevance: "Why this company is relevant",
      saving: "Saving…",
      save: "Save company",
      created: "Construction company created successfully.",
      createError: "The construction company could not be created.",
    },
    discovery: {
      back: "Back to Construction Partners",
      eyebrow: "Controlled public-source research",
      title: "Discover Construction Companies",
      subtitle: "Research official company sources, review professional contact details and import only complete records.",
      searchPlaceholder: "Company name or construction sector",
      country: "Country",
      officialUrl: "Known official website (optional)",
      search: "Search sources",
      searching: "Searching…",
      contactReady: "Contact ready",
      needsContact: "Needs contact",
      email: "Reviewed email",
      phone: "Reviewed telephone",
      reviewSource: "Review source",
      imported: "Already imported",
      importing: "Importing…",
      import: "Import company",
      searchError: "Company discovery failed.",
      importSuccess: "Company imported for review.",
      importError: "Company could not be imported.",
      ruleOfficial: "Review the official company website before importing.",
      ruleContact: "Email and telephone are mandatory for every imported company.",
      ruleReview: "Discovered information remains unverified until reviewed.",
      results: "candidate companies found",
      provider: "Provider",
      noResults: "No suitable official company candidates were found.",
    },
  },
  pt: {
    form: {
      eyebrow: "Perfil de parceiro verificado",
      title: "Adicionar empresa de construção",
      companyInformation: "Informações da empresa",
      name: "Nome da empresa",
      legalName: "Denominação legal",
      parentGroup: "Grupo empresarial",
      country: "País",
      city: "Cidade",
      website: "Website oficial",
      role: "Função da empresa",
      speciality: "Especialidade",
      capability: "Capacidade",
      description: "Descrição",
      professionalContact: "Contacto profissional",
      contactName: "Nome do contacto ou departamento",
      jobTitle: "Cargo",
      email: "Email",
      phone: "Telefone",
      contactSource: "URL da fonte do contacto",
      priority: "Prioridade",
      contactVerification: "Verificação do contacto",
      operatesPortugal: "A empresa opera em Portugal",
      relevance: "Por que esta empresa é relevante",
      saving: "A guardar…",
      save: "Guardar empresa",
      created: "Empresa de construção criada com sucesso.",
      createError: "Não foi possível criar a empresa de construção.",
    },
    discovery: {
      back: "Voltar aos Parceiros de Construção",
      eyebrow: "Pesquisa controlada em fontes públicas",
      title: "Descobrir Empresas de Construção",
      subtitle: "Pesquisar fontes oficiais, rever os contactos profissionais e importar apenas registos completos.",
      searchPlaceholder: "Nome da empresa ou setor de construção",
      country: "País",
      officialUrl: "Website oficial conhecido (opcional)",
      search: "Pesquisar fontes",
      searching: "A pesquisar…",
      contactReady: "Contacto completo",
      needsContact: "Contacto em falta",
      email: "Email revisto",
      phone: "Telefone revisto",
      reviewSource: "Rever fonte",
      imported: "Já importada",
      importing: "A importar…",
      import: "Importar empresa",
      searchError: "A pesquisa de empresas falhou.",
      importSuccess: "Empresa importada para revisão.",
      importError: "Não foi possível importar a empresa.",
      ruleOfficial: "Rever o website oficial da empresa antes da importação.",
      ruleContact: "Email e telefone são obrigatórios em todas as empresas importadas.",
      ruleReview: "A informação descoberta permanece não verificada até ser revista.",
      results: "empresas candidatas encontradas",
      provider: "Fornecedor",
      noResults: "Não foram encontradas empresas oficiais adequadas.",
    },
  },

  zh: {
    form: {
      eyebrow: "已验证合作伙伴档案",
      title: "添加建筑公司",
      companyInformation: "公司信息",
      name: "公司名称",
      legalName: "法定名称",
      parentGroup: "母公司集团",
      country: "国家",
      city: "城市",
      website: "官方网站",
      role: "公司角色",
      speciality: "专业领域",
      capability: "业务能力",
      description: "公司简介",
      professionalContact: "专业联系人",
      contactName: "联系人或部门名称",
      jobTitle: "职位",
      email: "电子邮箱",
      phone: "联系电话",
      contactSource: "联系信息来源网址",
      priority: "优先级",
      contactVerification: "联系人验证状态",
      operatesPortugal: "公司在葡萄牙开展业务",
      relevance: "该公司为何具有相关性",
      saving: "正在保存…",
      save: "保存公司",
      created: "建筑公司创建成功。",
      createError: "无法创建建筑公司。",
    },
    discovery: {
      back: "返回建筑合作伙伴",
      eyebrow: "受控公开来源研究",
      title: "发现建筑公司",
      subtitle: "搜索官方来源，审核专业联系信息，并仅导入资料完整的记录。",
      searchPlaceholder: "公司名称或建筑行业",
      country: "国家",
      officialUrl: "已知官方网站（可选）",
      search: "搜索来源",
      searching: "正在搜索…",
      contactReady: "联系信息完整",
      needsContact: "缺少联系信息",
      email: "已审核邮箱",
      phone: "已审核电话",
      reviewSource: "审核来源",
      imported: "已导入",
      importing: "正在导入…",
      import: "导入公司",
      searchError: "公司搜索失败。",
      importSuccess: "公司已导入并等待审核。",
      importError: "无法导入公司。",
      ruleOfficial: "导入前须审核公司的官方网站。",
      ruleContact: "所有导入公司必须提供电子邮箱和联系电话。",
      ruleReview: "发现的信息在人工审核前均保持未验证状态。",
      results: "家候选公司已找到",
      provider: "搜索服务商",
      noResults: "未找到合适的官方公司记录。",
    },
  },
  fr: {
    form: {
      eyebrow: "Profil de partenaire vérifié",
      title: "Ajouter une entreprise de construction",
      companyInformation: "Informations sur l’entreprise",
      name: "Nom de l’entreprise",
      legalName: "Dénomination sociale",
      parentGroup: "Groupe parent",
      country: "Pays",
      city: "Ville",
      website: "Site internet officiel",
      role: "Rôle de l’entreprise",
      speciality: "Spécialité",
      capability: "Capacité",
      description: "Description",
      professionalContact: "Contact professionnel",
      contactName: "Nom du contact ou du service",
      jobTitle: "Fonction",
      email: "E-mail",
      phone: "Téléphone",
      contactSource: "URL de la source du contact",
      priority: "Priorité",
      contactVerification: "Vérification du contact",
      operatesPortugal: "L’entreprise opère au Portugal",
      relevance: "Pourquoi cette entreprise est pertinente",
      saving: "Enregistrement…",
      save: "Enregistrer l’entreprise",
      created: "Entreprise de construction créée avec succès.",
      createError: "Impossible de créer l’entreprise de construction.",
    },
    discovery: {
      back: "Retour aux partenaires de construction",
      eyebrow: "Recherche contrôlée dans les sources publiques",
      title: "Découvrir des entreprises de construction",
      subtitle: "Rechercher les sources officielles, vérifier les contacts professionnels et importer uniquement les dossiers complets.",
      searchPlaceholder: "Nom de l’entreprise ou secteur de construction",
      country: "Pays",
      officialUrl: "Site officiel connu (facultatif)",
      search: "Rechercher les sources",
      searching: "Recherche en cours…",
      contactReady: "Contact complet",
      needsContact: "Contact manquant",
      email: "E-mail vérifié",
      phone: "Téléphone vérifié",
      reviewSource: "Vérifier la source",
      imported: "Déjà importée",
      importing: "Importation…",
      import: "Importer l’entreprise",
      searchError: "La recherche d’entreprises a échoué.",
      importSuccess: "Entreprise importée pour vérification.",
      importError: "Impossible d’importer l’entreprise.",
      ruleOfficial: "Vérifier le site officiel de l’entreprise avant l’importation.",
      ruleContact: "L’e-mail et le téléphone sont obligatoires pour chaque entreprise importée.",
      ruleReview: "Les informations découvertes restent non vérifiées jusqu’à leur examen.",
      results: "entreprises candidates trouvées",
      provider: "Fournisseur",
      noResults: "Aucune entreprise officielle appropriée n’a été trouvée.",
    },
  },

  es: {
    form: {
      eyebrow: "Perfil de socio verificado",
      title: "Añadir empresa constructora",
      companyInformation: "Información de la empresa",
      name: "Nombre de la empresa",
      legalName: "Razón social",
      parentGroup: "Grupo empresarial",
      country: "País",
      city: "Ciudad",
      website: "Sitio web oficial",
      role: "Función de la empresa",
      speciality: "Especialidad",
      capability: "Capacidad",
      description: "Descripción",
      professionalContact: "Contacto profesional",
      contactName: "Nombre del contacto o departamento",
      jobTitle: "Cargo",
      email: "Correo electrónico",
      phone: "Teléfono",
      contactSource: "URL de la fuente del contacto",
      priority: "Prioridad",
      contactVerification: "Verificación del contacto",
      operatesPortugal: "La empresa opera en Portugal",
      relevance: "Por qué esta empresa es relevante",
      saving: "Guardando…",
      save: "Guardar empresa",
      created: "Empresa constructora creada correctamente.",
      createError: "No se pudo crear la empresa constructora.",
    },
    discovery: {
      back: "Volver a Socios de Construcción",
      eyebrow: "Investigación controlada en fuentes públicas",
      title: "Descubrir Empresas Constructoras",
      subtitle: "Buscar fuentes oficiales, revisar los contactos profesionales e importar únicamente registros completos.",
      searchPlaceholder: "Nombre de la empresa o sector de construcción",
      country: "País",
      officialUrl: "Sitio web oficial conocido (opcional)",
      search: "Buscar fuentes",
      searching: "Buscando…",
      contactReady: "Contacto completo",
      needsContact: "Falta información de contacto",
      email: "Correo revisado",
      phone: "Teléfono revisado",
      reviewSource: "Revisar fuente",
      imported: "Ya importada",
      importing: "Importando…",
      import: "Importar empresa",
      searchError: "La búsqueda de empresas ha fallado.",
      importSuccess: "Empresa importada para revisión.",
      importError: "No se pudo importar la empresa.",
      ruleOfficial: "Revisar el sitio web oficial de la empresa antes de importarla.",
      ruleContact: "El correo electrónico y el teléfono son obligatorios para todas las empresas importadas.",
      ruleReview: "La información descubierta permanece sin verificar hasta su revisión.",
      results: "empresas candidatas encontradas",
      provider: "Proveedor",
      noResults: "No se encontraron empresas oficiales adecuadas.",
    },
  },
  de: {
    form: {
      eyebrow: "Verifiziertes Partnerprofil",
      title: "Bauunternehmen hinzufügen",
      companyInformation: "Unternehmensinformationen",
      name: "Unternehmensname",
      legalName: "Rechtlicher Firmenname",
      parentGroup: "Mutterkonzern",
      country: "Land",
      city: "Stadt",
      website: "Offizielle Website",
      role: "Unternehmensrolle",
      speciality: "Fachgebiet",
      capability: "Kompetenz",
      description: "Beschreibung",
      professionalContact: "Geschäftlicher Kontakt",
      contactName: "Name der Kontaktperson oder Abteilung",
      jobTitle: "Position",
      email: "E-Mail",
      phone: "Telefon",
      contactSource: "URL der Kontaktquelle",
      priority: "Priorität",
      contactVerification: "Kontaktverifizierung",
      operatesPortugal: "Das Unternehmen ist in Portugal tätig",
      relevance: "Warum dieses Unternehmen relevant ist",
      saving: "Wird gespeichert…",
      save: "Unternehmen speichern",
      created: "Bauunternehmen erfolgreich erstellt.",
      createError: "Das Bauunternehmen konnte nicht erstellt werden.",
    },
    discovery: {
      back: "Zurück zu Baupartnern",
      eyebrow: "Kontrollierte Recherche in öffentlichen Quellen",
      title: "Bauunternehmen entdecken",
      subtitle: "Offizielle Quellen durchsuchen, Geschäftskontakte prüfen und nur vollständige Datensätze importieren.",
      searchPlaceholder: "Unternehmensname oder Baubereich",
      country: "Land",
      officialUrl: "Bekannte offizielle Website (optional)",
      search: "Quellen durchsuchen",
      searching: "Suche läuft…",
      contactReady: "Kontakt vollständig",
      needsContact: "Kontaktdaten fehlen",
      email: "Geprüfte E-Mail",
      phone: "Geprüfte Telefonnummer",
      reviewSource: "Quelle prüfen",
      imported: "Bereits importiert",
      importing: "Wird importiert…",
      import: "Unternehmen importieren",
      searchError: "Die Unternehmenssuche ist fehlgeschlagen.",
      importSuccess: "Unternehmen zur Prüfung importiert.",
      importError: "Das Unternehmen konnte nicht importiert werden.",
      ruleOfficial: "Die offizielle Website des Unternehmens vor dem Import prüfen.",
      ruleContact: "E-Mail und Telefonnummer sind für jedes importierte Unternehmen erforderlich.",
      ruleReview: "Gefundene Informationen bleiben bis zur Prüfung unverifiziert.",
      results: "potenzielle Unternehmen gefunden",
      provider: "Suchanbieter",
      noResults: "Keine geeigneten offiziellen Unternehmen gefunden.",
    },
  },

  it: {
    form: {
      eyebrow: "Profilo partner verificato",
      title: "Aggiungi impresa di costruzioni",
      companyInformation: "Informazioni sull’impresa",
      name: "Nome dell’impresa",
      legalName: "Ragione sociale",
      parentGroup: "Gruppo di appartenenza",
      country: "Paese",
      city: "Città",
      website: "Sito web ufficiale",
      role: "Ruolo dell’impresa",
      speciality: "Specializzazione",
      capability: "Capacità",
      description: "Descrizione",
      professionalContact: "Contatto professionale",
      contactName: "Nome del contatto o del reparto",
      jobTitle: "Ruolo professionale",
      email: "E-mail",
      phone: "Telefono",
      contactSource: "URL della fonte del contatto",
      priority: "Priorità",
      contactVerification: "Verifica del contatto",
      operatesPortugal: "L’impresa opera in Portogallo",
      relevance: "Perché questa impresa è rilevante",
      saving: "Salvataggio…",
      save: "Salva impresa",
      created: "Impresa di costruzioni creata con successo.",
      createError: "Impossibile creare l’impresa di costruzioni.",
    },
    discovery: {
      back: "Torna ai Partner di Costruzione",
      eyebrow: "Ricerca controllata su fonti pubbliche",
      title: "Scopri Imprese di Costruzioni",
      subtitle: "Cerca fonti ufficiali, verifica i contatti professionali e importa soltanto record completi.",
      searchPlaceholder: "Nome dell’impresa o settore delle costruzioni",
      country: "Paese",
      officialUrl: "Sito ufficiale conosciuto (facoltativo)",
      search: "Cerca fonti",
      searching: "Ricerca in corso…",
      contactReady: "Contatto completo",
      needsContact: "Contatto mancante",
      email: "E-mail verificata",
      phone: "Telefono verificato",
      reviewSource: "Verifica fonte",
      imported: "Già importata",
      importing: "Importazione…",
      import: "Importa impresa",
      searchError: "La ricerca delle imprese non è riuscita.",
      importSuccess: "Impresa importata per la verifica.",
      importError: "Impossibile importare l’impresa.",
      ruleOfficial: "Verificare il sito ufficiale dell’impresa prima dell’importazione.",
      ruleContact: "E-mail e telefono sono obbligatori per ogni impresa importata.",
      ruleReview: "Le informazioni trovate rimangono non verificate fino alla revisione.",
      results: "imprese candidate trovate",
      provider: "Fornitore",
      noResults: "Nessuna impresa ufficiale adeguata trovata.",
    },
  },
  ru: {
    form: {
      eyebrow: "Проверенный профиль партнёра",
      title: "Добавить строительную компанию",
      companyInformation: "Информация о компании",
      name: "Название компании",
      legalName: "Юридическое наименование",
      parentGroup: "Материнская группа",
      country: "Страна",
      city: "Город",
      website: "Официальный сайт",
      role: "Роль компании",
      speciality: "Специализация",
      capability: "Компетенция",
      description: "Описание",
      professionalContact: "Деловой контакт",
      contactName: "Имя контакта или отдел",
      jobTitle: "Должность",
      email: "Электронная почта",
      phone: "Телефон",
      contactSource: "URL источника контакта",
      priority: "Приоритет",
      contactVerification: "Проверка контакта",
      operatesPortugal: "Компания работает в Португалии",
      relevance: "Почему эта компания актуальна",
      saving: "Сохранение…",
      save: "Сохранить компанию",
      created: "Строительная компания успешно создана.",
      createError: "Не удалось создать строительную компанию.",
    },
    discovery: {
      back: "Назад к строительным партнёрам",
      eyebrow: "Контролируемый поиск по открытым источникам",
      title: "Поиск Строительных Компаний",
      subtitle: "Ищите официальные источники, проверяйте деловые контакты и импортируйте только полные записи.",
      searchPlaceholder: "Название компании или строительный сектор",
      country: "Страна",
      officialUrl: "Известный официальный сайт (необязательно)",
      search: "Искать источники",
      searching: "Поиск…",
      contactReady: "Контактные данные полные",
      needsContact: "Контактные данные отсутствуют",
      email: "Проверенная почта",
      phone: "Проверенный телефон",
      reviewSource: "Проверить источник",
      imported: "Уже импортирована",
      importing: "Импорт…",
      import: "Импортировать компанию",
      searchError: "Поиск компаний завершился ошибкой.",
      importSuccess: "Компания импортирована для проверки.",
      importError: "Не удалось импортировать компанию.",
      ruleOfficial: "Проверьте официальный сайт компании перед импортом.",
      ruleContact: "Электронная почта и телефон обязательны для каждой импортируемой компании.",
      ruleReview: "Найденная информация остаётся непроверенной до завершения проверки.",
      results: "компаний-кандидатов найдено",
      provider: "Поставщик поиска",
      noResults: "Подходящие официальные компании не найдены.",
    },
  },
};

Object.entries(constructionPartnerWorkflowTranslations).forEach(
  ([language, workflow]) => {
    Object.assign(constructionPartnerTranslations[language], workflow);
  }
);


const developmentProjectPartnerLabels = {
  en: {
    navigation: "Development & Project Partners",
    eyebrow: "Panatlantik project delivery intelligence",
    title: "Development & Project Partners",
    subtitle: "Verified architects, engineers, consultants, contractors, developers, investors and project-originating partners.",
    form: {
      eyebrow: "Verified project-partner profile",
      title: "Add development or project partner",
      created: "Development and project partner created successfully.",
      createError: "Development and project partner could not be created.",
    },
    discovery: {
      back: "Back to Development & Project Partners",
      title: "Discover Development & Project Partners",
      searchPlaceholder: "Company name, profession or project sector",
      role: "Partner role",
      allRoles: "All partner roles",
      capability: "Required capability",
      allCapabilities: "All capabilities",
    },
  },
  pt: {
    navigation: "Parceiros de Desenvolvimento e Projeto",
    eyebrow: "Inteligência de execução de projetos Panatlantik",
    title: "Parceiros de Desenvolvimento e Projeto",
    subtitle: "Arquitetos, engenheiros, consultores, empreiteiros, promotores, investidores e parceiros de originação verificados.",
    form: {
      eyebrow: "Perfil verificado de parceiro de projeto",
      title: "Adicionar parceiro de desenvolvimento ou projeto",
      created: "Parceiro de desenvolvimento e projeto criado com sucesso.",
      createError: "Não foi possível criar o parceiro de desenvolvimento e projeto.",
    },
    discovery: {
      back: "Voltar aos Parceiros de Desenvolvimento e Projeto",
      title: "Descobrir Parceiros de Desenvolvimento e Projeto",
      searchPlaceholder: "Nome da empresa, profissão ou setor do projeto",
      role: "Função do parceiro",
      allRoles: "Todas as funções",
      capability: "Capacidade necessária",
      allCapabilities: "Todas as capacidades",
    },
  },
  zh: {
    navigation: "开发与项目合作伙伴",
    eyebrow: "Panatlantik项目交付情报",
    title: "开发与项目合作伙伴",
    subtitle: "经核验的建筑师、工程师、顾问、承包商、开发商、投资者及项目发掘合作伙伴。",
    form: {
      eyebrow: "已验证的项目合作伙伴档案",
      title: "添加开发或项目合作伙伴",
      created: "开发与项目合作伙伴创建成功。",
      createError: "无法创建开发与项目合作伙伴。",
    },
    discovery: {
      back: "返回开发与项目合作伙伴",
      title: "发现开发与项目合作伙伴",
      searchPlaceholder: "公司名称、专业或项目领域",
      role: "合作伙伴角色",
      allRoles: "所有合作伙伴角色",
      capability: "所需能力",
      allCapabilities: "所有能力",
    },
  },
  fr: {
    navigation: "Partenaires de Développement et de Projet",
    eyebrow: "Intelligence d’exécution de projets Panatlantik",
    title: "Partenaires de Développement et de Projet",
    subtitle: "Architectes, ingénieurs, consultants, entrepreneurs, promoteurs, investisseurs et apporteurs de projets vérifiés.",
    form: {
      eyebrow: "Profil vérifié de partenaire de projet",
      title: "Ajouter un partenaire de développement ou de projet",
      created: "Partenaire de développement et de projet créé avec succès.",
      createError: "Impossible de créer le partenaire de développement et de projet.",
    },
    discovery: {
      back: "Retour aux Partenaires de Développement et de Projet",
      title: "Découvrir des Partenaires de Développement et de Projet",
      searchPlaceholder: "Nom de l’entreprise, profession ou secteur du projet",
      role: "Rôle du partenaire",
      allRoles: "Tous les rôles",
      capability: "Capacité requise",
      allCapabilities: "Toutes les capacités",
    },
  },
  es: {
    navigation: "Socios de Desarrollo y Proyecto",
    eyebrow: "Inteligencia de ejecución de proyectos Panatlantik",
    title: "Socios de Desarrollo y Proyecto",
    subtitle: "Arquitectos, ingenieros, consultores, contratistas, promotores, inversores y socios de originación verificados.",
    form: {
      eyebrow: "Perfil verificado de socio de proyecto",
      title: "Añadir socio de desarrollo o proyecto",
      created: "Socio de desarrollo y proyecto creado correctamente.",
      createError: "No se pudo crear el socio de desarrollo y proyecto.",
    },
    discovery: {
      back: "Volver a Socios de Desarrollo y Proyecto",
      title: "Descubrir Socios de Desarrollo y Proyecto",
      searchPlaceholder: "Nombre de empresa, profesión o sector del proyecto",
      role: "Función del socio",
      allRoles: "Todas las funciones",
      capability: "Capacidad requerida",
      allCapabilities: "Todas las capacidades",
    },
  },
  de: {
    navigation: "Entwicklungs- und Projektpartner",
    eyebrow: "Panatlantik-Projektrealisierungsinformationen",
    title: "Entwicklungs- und Projektpartner",
    subtitle: "Verifizierte Architekten, Ingenieure, Berater, Bauunternehmen, Entwickler, Investoren und Projektvermittler.",
    form: {
      eyebrow: "Verifiziertes Projektpartnerprofil",
      title: "Entwicklungs- oder Projektpartner hinzufügen",
      created: "Entwicklungs- und Projektpartner erfolgreich erstellt.",
      createError: "Der Entwicklungs- und Projektpartner konnte nicht erstellt werden.",
    },
    discovery: {
      back: "Zurück zu Entwicklungs- und Projektpartnern",
      title: "Entwicklungs- und Projektpartner entdecken",
      searchPlaceholder: "Unternehmensname, Beruf oder Projektbereich",
      role: "Partnerrolle",
      allRoles: "Alle Partnerrollen",
      capability: "Erforderliche Kompetenz",
      allCapabilities: "Alle Kompetenzen",
    },
  },
  it: {
    navigation: "Partner di Sviluppo e Progetto",
    eyebrow: "Intelligence Panatlantik per la realizzazione dei progetti",
    title: "Partner di Sviluppo e Progetto",
    subtitle: "Architetti, ingegneri, consulenti, imprese, sviluppatori, investitori e partner di origination verificati.",
    form: {
      eyebrow: "Profilo verificato del partner di progetto",
      title: "Aggiungi partner di sviluppo o progetto",
      created: "Partner di sviluppo e progetto creato con successo.",
      createError: "Impossibile creare il partner di sviluppo e progetto.",
    },
    discovery: {
      back: "Torna ai Partner di Sviluppo e Progetto",
      title: "Scopri Partner di Sviluppo e Progetto",
      searchPlaceholder: "Nome dell’impresa, professione o settore del progetto",
      role: "Ruolo del partner",
      allRoles: "Tutti i ruoli",
      capability: "Capacità richiesta",
      allCapabilities: "Tutte le capacità",
    },
  },
  ru: {
    navigation: "Партнёры по Девелопменту и Проектам",
    eyebrow: "Аналитика Panatlantik по реализации проектов",
    title: "Партнёры по Девелопменту и Проектам",
    subtitle: "Проверенные архитекторы, инженеры, консультанты, подрядчики, девелоперы, инвесторы и партнёры по поиску проектов.",
    form: {
      eyebrow: "Проверенный профиль проектного партнёра",
      title: "Добавить партнёра по девелопменту или проекту",
      created: "Партнёр по девелопменту и проектам успешно создан.",
      createError: "Не удалось создать партнёра по девелопменту и проектам.",
    },
    discovery: {
      back: "Назад к Партнёрам по Девелопменту и Проектам",
      title: "Поиск Партнёров по Девелопменту и Проектам",
      searchPlaceholder: "Название компании, профессия или сектор проекта",
      role: "Роль партнёра",
      allRoles: "Все роли партнёров",
      capability: "Требуемая компетенция",
      allCapabilities: "Все компетенции",
    },
  },
};

Object.entries(developmentProjectPartnerLabels).forEach(
  ([language, labels]) => {
    const { form, discovery, ...root } = labels;
    Object.assign(constructionPartnerTranslations[language], root);
    Object.assign(constructionPartnerTranslations[language].form, form);
    Object.assign(
      constructionPartnerTranslations[language].discovery,
      discovery
    );
  }
);

export default constructionPartnerTranslations;
